import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: left;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 12px;
  color: var(--secondary-text-color);
  padding: 3px 7px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 100px;
  margin-left: 8px;
`;

export const BetaLabel: React.FC = () => {
  return <Wrapper>Beta</Wrapper>;
};



// WEBPACK FOOTER //
// ./src/account/components/BetaLabel.tsx